import { render, staticRenderFns } from "./BlogComponent.vue?vue&type=template&id=1fb96ee6&scoped=true"
import script from "./BlogComponent.vue?vue&type=script&lang=js"
export * from "./BlogComponent.vue?vue&type=script&lang=js"
import style0 from "./BlogComponent.vue?vue&type=style&index=0&id=1fb96ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb96ee6",
  null
  
)

export default component.exports